const ProjectList = [
  {
    projectName: "Valora",
    icon: "../assets/projects/valora/logo.png",
    description:
    "Valora is a multimodal AI platform that revolutionizes interview prep by transforming your PDF Resume and Job Description into a live, vocal technical interview.",
    info: [
      "React.Js, Express.Js, Node.Js, Firebase",
    ],
    platform: "Website",
    gitLink: "https://github.com/Atharv-28/Valora",
    snapshots: [
      "../assets/projects/valora/ss1.png",
      "../assets/projects/valora/ss2.png",
      "../assets/projects/valora/ss3.png",
      "../assets/projects/valora/ss4.png",
    ],
    liveLink: "https://valora-5a3k.onrender.com/",
  },
  {
    projectName: "Expense Track & Analyse",
    icon: "../assets/projects/eta/logo.png",
    description:
      "Expense Track & Analyse is a project that provides users with real-time updates on their transactions. It is integrated with sms broadcaster to fetch transactions live data and offers a user-friendly interface for tracking timely expenses with categories.",
    info: ["React-Native CLI, JAVA"],
    platform: "Android App",
    gitLink: "https://github.com/Atharv-28/E.T.A.",
    snapshots: [
      "../assets/projects/eta/ss1.jpg",
      "../assets/projects/eta/ss2.jpg",
      "../assets/projects/eta/ss3.jpg",
      "../assets/projects/eta/ss4.jpg",
      "../assets/projects/eta/ss5.jpg",
      "../assets/projects/eta/ss6.jpg",

    ],
    liveLink: "",
  },
  {
    projectName: "Eco-Cart",
    icon: "../assets/projects/ecoCart/logo.jpg",
    description:
    "Eco-Cart is an e-commerce platform focused on eco-friendly products. It allows users to browse and purchase sustainable items, promoting a greener lifestyle. Built with React, it features a modern design and user-friendly interface for an enjoyable shopping experience.",
    info: [
      "React.Js, React Native + Expo, Express.Js, Node.Js, Flask, Python, Firebase",
    ],
    platform: "Website & Android App",
    gitLink: "",
    snapshots: [
      "../assets/projects/ecoCart/ss1.png",
      "../assets/projects/ecoCart/ss2.png",
      "../assets/projects/ecoCart/ss3.png",
      "../assets/projects/ecoCart/ss4.png",
      "../assets/projects/ecoCart/ms1.jpg",
      "../assets/projects/ecoCart/ms2.jpg",
      "../assets/projects/ecoCart/ms3.jpg",
    ],
    liveLink: "https://eco-cart-frontend.vercel.app/",
  },
  {
    projectName: "Nutri-Veda",
    icon: "../assets/projects/nutriVeda/logo.png",
    description:
      "NutriVeda is a React Native mobile app that provides personalized Ayurvedic diet plans based on Prakruti (body constitution) assessment, featuring patient-doctor collaboration, real-time diet plan management, and appointment booking. Built with Expo, React Native, Firebase (Authentication & Firestore), and integrates an intelligent diet engine that generates customized meal recommendations based on dosha types (Vata, Pitta, Kapha) with doctor oversight and approval workflow.",
    info: ["React-Native + Expo, Firebase"],
    platform: "Android App",
    snapshots: [
      "../assets/projects/nutriVeda/ss1.jpg",
      "../assets/projects/nutriVeda/ss2.jpg",
      "../assets/projects/nutriVeda/ss3.jpg",
      "../assets/projects/nutriVeda/ss4.jpg",
      "../assets/projects/nutriVeda/ss5.jpg",
      "../assets/projects/nutriVeda/ss6.png",
      "../assets/projects/nutriVeda/ss7.png",
      "../assets/projects/nutriVeda/ss8.png",
      "../assets/projects/nutriVeda/ss9.png",
    ],
    gitLink: "https://github.com/Atharv-28/nutri-veda"
  },
  {
    projectName: "Yog-fit",
    icon: "../assets/projects/yogFit/yogFitIco.png",
    description:
      "Yog-fit is my final year capstone project. This application promotes fitness and wellness through yoga. It provides users with yoga routines, tracking their progress and offering personalized recommendations. Built with React Native, it aims to make yoga accessible and enjoyable.",
    info: ["React-Native + Expo, Firebase"],
    platform: "Android App",
    gitLink: "https://github.com/Atharv-28/Yog-fit",
    snapshots: [
      "../assets/projects/yogFit/yf1.jpg",
      "../assets/projects/yogFit/yf2.jpg",
    ],
    liveLink: "",
  },
  {
    projectName: "Radhey Travel",
    icon: "../assets/projects/radheyTravelIco.png",
    description: "A vehicle rental service platform that allows users to book vehicles for travel. Built for a client on a freelance basis, this platform offers a seamless booking experience with various vehicle options and user-friendly features.",
    info: ["HTML, CSS, JavaScript, API"],
    platform: "Website",
    gitLink: "https://github.com/rajveervchandaliya/Radhey-Travels",
    snapshots: [
      "../assets/projects/radhey1.png",
      "../assets/projects/radhey2.png",
      "../assets/projects/radhey3.png",
    ],
    liveLink: "https://radheytravel.in/",
  },
  {
    projectName: "Solar-Sim",
    icon: "../assets/projects/solarSim/logo.png",
    description:
      "SolarSim is an interactive solar system simulation that allows users to explore planets, edit their properties, and visualize their orbits. The project includes features like zooming, panning, responsive design, and real-world scaling of planetary data.",
    info: ["React.Js, Canvas, React-States"],
    platform: "Website",
    gitLink: "https://github.com/Atharv-28/solarsim",
    snapshots: [
      "../assets/projects/solarSim/ss1.png",
      "../assets/projects/solarSim/ss2.png",
    ],
    liveLink: "https://solarsim-wine.vercel.app/",
  },
  {
    projectName: "Twiller",
    icon: "../assets/projects/twiller.png",
    description:
      "Worked on the project in internship at NULL CLASS & developed Few important features in M-E-R-N Stack. Improved the UI/UX & had a hands-on experience on the project with deployment & testing. This social media platform allows users to post tweets, follow other users, and engage with content. It was built using React for the frontend, Express.Js for the backend, and MongoDB as the database, providing a seamless user experience.",
    info: ["React.Js, Express.Js, MongoDB, Firebase, Node.Js"],
    platform: "Website",
    gitLink: "https://github.com/Atharv-28/twiller-twitterclone",
    snapshots: [
      "../assets/projects/tw1.png",
      "../assets/projects/tw2.png",
      "../assets/projects/tw3.png",
    ],
    liveLink: "https://twiller-twitter-clone.netlify.app/",
  },
  {
    projectName: "News Buzz",
    icon: "../assets/projects/newsBuzzIco.ico",
    description:
      "I created News Buzz as an assignment for Persist Ventures. This web application is designed to keep users updated with the latest news. It fetches news articles from various sources and displays them in an organized manner. Key features include real-time news updates, categorization for easy navigation, and a clean, user-friendly interface for browsing news.",
    info: ["React, Api's, Router, Redux, Pagination, Search Algorithm"],
    platform: "Website",
    gitLink: "https://github.com/Atharv-28/news-buzz",
    snapshots: ["../assets/projects/nz1.png"],
    liveLink: "https://news-buzz-seven.vercel.app/",
  },
  {
    projectName: "MCQ App",
    icon: "../assets/projects/mcq/mcqIco.ico",
    description:
      "I developed the MCQ App. This web application allows users to practice multiple-choice questions, providing a platform for learning and self-assessment. It was built using NextJS and offers a user-friendly interface for an engaging experience. IT has Features like ranking, difficulty levels and analysis dashboard.",
    info: ["NEXT.Js, Express.Js, POSTGRE SQL, Tailwind CSS, API's"],
    platform: "Website",
    gitLink: "https://github.com/Atharv-28/mcqq",
    snapshots: [
      "../assets/projects/mcq/ss1.png",
      "../assets/projects/mcq/ss2.png",
      "../assets/projects/mcq/ss3.png",
      "../assets/projects/mcq/ss4.png",
    ],
    liveLink: "https://mcqq-seven.vercel.app/",
  },
  {
    projectName: "Water Level",
    icon: "../assets/projects/waterLevelIco.png",
    description:
      "I developed the Water Level project to monitor the water level in my house's tank. This IoT solution uses sensors and a mobile app, with Firebase as the database, to detect and display water levels. It helps in managing water resources efficiently.",
    info: ["Iot, c++, Arduino, Firebase, React-Native + Expo"],
    platform: "Android App & IoT",
    gitLink: "https://github.com/Atharv-28/WaterLevel",
    snapshots: [],
    liveLink: "",
  }
];

export default ProjectList;
